var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visually-hidden"},[_c('h1',{staticClass:"H1title",attrs:{"id":"H1title"}},[_vm._v(" "+_vm._s(_vm.titleName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }